var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.loading)?_c(_vm.layout,{tag:"component"},[_c('router-view',{key:_vm.key,attrs:{"layout":_vm.layout},on:{"update:layout":function($event){_vm.layout=$event}}})],1):_vm._e(),_c('Wizard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }